import { ReactNode } from 'react'

import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

import { ICalendarPriceResponse } from 'shared/api/Calendar'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { SelectedDaysDifficult } from 'shared/ui/month-wrapper'

export enum TYPE_FLY {
  DIRECT = 'direct',
  RETURN = 'return',
}

export enum TYPE_DATE {
  START_DATE = 'startDate',
  END_DATE = 'endDate',
}

export interface IRange {
  startDate?: string
  endDate?: string
}

export interface DisabledDays {
  date: string
}

export type TYPE_CALENDAR =
  | 'avia'
  | 'aviaDifficult'
  | 'insurance'
  | 'excursion'
  | 'insuranceYear'
  | 'beket'
  | 'tour'

export interface Props {
  type?: TYPE_FLY
  difficult?: boolean
  selectedDate: IRange
  activeDays?: string[]
  lastRangeDate?: string
  indexDirection?: number
  isPriceCalendar?: boolean
  direction?: DifficultRoute
  focusDate?: string
  header?: ReactNode
  showRange?: boolean
  showResetIcon?: boolean
  dateFormat?: DATE_FORMAT_LIST
  selectedDates?: SelectedDaysDifficult[]
  calendarPrices?: ICalendarPriceResponse[] | null
  typeCalendar?: TYPE_CALENDAR
  confirmText?: string
  placeholders?: {
    from?: string
    to?: string
  }
  onChange?: (data: IRange) => void
  triggerCalendar?: (date?: string) => void
  maxMonth?: number
  maxRangeDays?: number
}

export interface ButtonActive {
  typeCalendar?: TYPE_CALENDAR
  selectedDates?: IRange | null
  confirmText?: string
  onClick?: () => void
}
